import "./Switcher.style.css";

import React, { ReactElement, useState } from "react";
import { Button, ButtonColor, ButtonSize } from "../Button/Button";

interface SwitcherItem {
  content: string | ReactElement;
  onActive?: () => void;
}

interface SwitcherProps {
  color?: ButtonColor;
  size?: ButtonSize;
  items: SwitcherItem[];
  startingItem?: number;
  vertical?: boolean;
  className?: string;
  style?: React.CSSProperties;
}

export const Switcher = ({
  color = ButtonColor.Primary,
  size = ButtonSize.Medium,
  items,
  startingItem,
  vertical,
  className = "",
  style = {},
}: SwitcherProps) => {
  const [activeItem, setActiveItem] = useState(startingItem);

  const handleItemClick = (item: SwitcherItem, idx: number) => {
    setActiveItem(idx);
    if (item.onActive) {
      item.onActive();
    }
  };

  return (
    <div
      className={`switcher ${className} ${vertical ? "switcher_vertical" : ""}`}
      style={style}
    >
      {items.map((item, idx) => {
        const itemColor = activeItem === idx ? color : ButtonColor.Empty;
        if (typeof item.content === "string") {
          return (
            <Button
              className={`switcher__item`}
              key={idx}
              color={itemColor}
              size={size}
              text={item.content}
              onClick={() => handleItemClick(item, idx)}
            />
          );
        }
        return (
          <Button
            className={`switcher__item`}
            key={idx}
            color={itemColor}
            size={size}
            icon={item.content}
            onClick={() => handleItemClick(item, idx)}
          />
        );
      })}
    </div>
  );
};
